<template>
	<div class="login">
		<div class="navigation">
			<el-image class="logo-img" :src="require('@/assets/img/logo.png')" fit="contain" />
		</div>
		<div class="content">
			<div class="title">注册</div>
			<el-form :model="registerForm" :rules="registerRules" ref="registerForm" class="login-ruleForm">
				<el-form-item prop="phone" v-if="stepOneShow">
					<el-input prefix-icon="el-icon-mobile" placeholder="请输入手机号" v-model="registerForm.phone">
					</el-input>
				</el-form-item>
				<el-form-item prop="code" v-if="stepOneShow">
					<el-input prefix-icon="el-icon-document-checked" placeholder="请输入验证码" v-model="registerForm.code">
					</el-input>
					<el-button class="code-btn" type="primary" size="mini" @click="sendCode" :disabled="codeDisabled">
						{{send}}
					</el-button>
				</el-form-item>
				<el-form-item prop="password" v-if="stepOneShow">
					<el-input prefix-icon="el-icon-lock" placeholder="请输入登录密码" type="password"
						v-model="registerForm.password"></el-input>
				</el-form-item>
				<el-form-item prop="companyName" v-if="!stepOneShow">
					<el-input prefix-icon="el-icon-s-custom" placeholder="请输入公司名称" v-model="registerForm.companyName">
					</el-input>
				</el-form-item>
				<el-form-item prop="selectedOptions" v-if="!stepOneShow">
					<i class="iconfont">&#xe614;</i>
					<el-cascader size="large" :options="options" placeholder="请选择省市区"
						v-model="registerForm.selectedOptions" @change="addressChange">
					</el-cascader>
				</el-form-item>
				<el-form-item prop="contact" v-if="!stepOneShow">
					<el-input prefix-icon="el-icon-s-custom" placeholder="请输入姓名" v-model="registerForm.contact">
					</el-input>
				</el-form-item>
				<el-form-item prop="contactPhone" v-if="!stepOneShow">
					<el-input prefix-icon="el-icon-mobile" placeholder="请输入联系电话" v-model="registerForm.contactPhone">
					</el-input>
				</el-form-item>
				<el-form-item prop="jobNo" v-if="!stepOneShow">
					<el-input prefix-icon="el-icon-postcard" placeholder="请输入工号" v-model="registerForm.jobNo">
					</el-input>
				</el-form-item>
				<el-form-item>
					<el-button class="main-btn" type="primary" @click="registerSubmit('registerForm')">
						{{registerBtnText}}
					</el-button>
				</el-form-item>
			</el-form>
			<div class="link">
				<router-link to="/"><span>登录</span></router-link>
				<!-- <router-link to="/forgotPassword"><span>忘记密码</span></router-link> -->
			</div>
		</div>

		<div class="footer">
			<span>玉韦耶克物联有限公司版权所有</span>
			<span>全国服务热线：400-6767-225</span>
			<span>www.yuweiyeke.com</span>
		</div>
	</div>
</template>

<script>
	// import http from "../http.js";
	import {
		regionData
	} from 'element-china-area-data'
	import {
		sendSms,
		userReg
	} from "@/api/user";
	export default {
		data() {
			return {
				stepOneShow: true,
				registerBtnText: '下一步',
				codeDisabled: false,
				send: '发送验证码',
				options: regionData, //省市区数据
				registerForm: {
					type: 1,
					phone: "",
					code: "",
					password: "",
					companyName: '',
					addressCode: '',
					contactPhone: '',
					contact: '',
					jobNo: '',
					selectedOptions: [],
				},
				registerRules: {
					phone: [{
							required: true,
							message: "请输入手机号",
							trigger: "blur"
						},
						{
							pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
							message: "请输入正确的手机号",
							trigger: "blur",
						}
					],
					code: [{
						required: true,
						min: 4,
						max: 4,
						message: "请输入4位验证码",
						trigger: "blur",
					}],
					password: [{
							required: true,
							message: "请输入登录密码",
							trigger: "blur"
						},
						{
							min: 8,
							max: 16,
							pattern: /^(?![a-zA-Z]+$)(?!\d+$)(?![^\da-zA-Z\s]+$).{8,16}$/,
							message: "由字母、数字、特殊字符，任意2种组成，8-16位",
							trigger: "blur",
						},
					],
					companyName: [{
						required: true,
						message: '请选择保险公司',
						trigger: 'change'
					}],
					selectedOptions: [{
						required: true,
						message: '请选择省市区',
						trigger: 'change'
					}],
					name: [{
						required: true,
						message: "请输入姓名",
						trigger: "blur",
					}],
					contactPhone: [{
							required: true,
							message: "请输入联系电话",
							trigger: "blur"
						},
						{
							pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
							message: "请输入正确的手机号",
							trigger: "blur",
						}
					],
					jobNo: [{
						required: true,
						message: "请输入工号",
						trigger: "blur",
					}],
				},
			}
		},
		methods: {
			addressChange(val) {
				console.log(val)
				this.registerForm.addressCode = val.join(',')
			},
			registerSubmit(formName) {
				if (this.stepOneShow) {
					this.$refs[formName].validate((valid) => {
						if (valid) {
							this.stepOneShow = false
							this.registerBtnText = "立即注册"
						} else {
							console.log('error submit!!');
							return false;
						}
					});
				} else {
					this.$refs[formName].validate((valid) => {
						if (valid) {
							userReg({
								...this.registerForm
							}).then(() => {
								this.$message.success('注册成功，请等待审核')
								this.registerVisible = false
								this.$router.push('/')
							})
						} else {
							console.log('error submit!!');
							return false;
						}
					});
				}

			},
			sendCode() {
				if (!this.registerForm.phone) {
					this.$message.error('请输入手机号')
					return
				}
				sendSms({
					phone: this.registerForm.phone
				}).then(() => {
					this.$message.success('发送成功')
					let _this = this
					_this.codeDisabled = true;
					var time = 60; //时间为10s，可以按情况更改
					var timer = setInterval(fun, 1000); //设置定时器
					function fun() {
						time--;
						if (time >= 0) {
							_this.send = time + "s后重新发送";
						} else if (time < 0) {
							_this.send = "重新发送验证码";
							_this.codeDisabled = false; //倒计时结束能够重新点击发送的按钮
							clearInterval(timer); //清除定时器
							time = 60; //设置循环重新开始条件
						}
					}
				})
			},
		}
	}
</script>

<style lang="scss">
	//scss
</style>
